interface Props {
	children?: JSX.Element | Array<JSX.Element>;
}

const AuthFormContainer = (props: Props): JSX.Element => {
	const { children } = props;

	return (
		<div className="flex bg-background border border-border shadow-[0_10px_25px_rgba(0,0,0,0.45)] rounded-2xl w-[min(980px,90vw)] h-[min(720px,80vh)] overflow-hidden md:w-screen md:h-screen md:rounded-none md:border-l-0 md:border-r-0 md:border-b-0">
			{children}
		</div>
	);
};

export default AuthFormContainer;
